(function () {
    $ (function () {
        $ (document).on ("click", ".js-sub__form-submit", function (e) {
            $ (document).trigger ("uiEvent", [
                {
                    event: 'UI',
                    code: 'formGiftSubmitClick'
                }
            ]);
        });
        
        $ (document).on ("click", ".js-blog-form__submit", function (e) {
            $ (document).trigger ("uiEvent", [
                {
                    event: 'UI',
                    code: 'formBlogSubmitClick'
                }
            ]);
        });
        
        $ (document).on ("is:success", ".js-sub__form", function (e, response) {
            const $form = $ (this);
            const $wrap = $form.closest (".js-sub");
            
            $wrap.find (".js-sub__success").each (function () {
                $ (this).removeClass ("_hidden");
            });
            
            if ($form.hasClass ("_postSub")) {
                $form.find (".b-form-sub__top").remove ();
                $form.find (".b-form-sub__btn").remove ();
                
            } else if ($form.hasClass ("_bottomSub")) {
                $form.remove ();
            }
    
            const evData = {
                event: 'UI',
                code: $form.data ("ev-code"),
                data: {
                    email: globalFunctions.escapeStr ($form.find ("[name=\"email\"]").val ())
                }
            };
            if (response.userId !== undefined) {
                evData.data.userId = globalFunctions.escapeStr (response.userId);
            }
            
            // собираем объект для аналитики
            $ (document).trigger ("uiEvent", [evData]);
        });
        
        $ (document).on ("is:fail", ".js-sub__form", function (e, response) {
            $ (document).trigger ('is:errorModal', {title: "Произошла ошибка!", text: ""});
        });
    })
} ());
